import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

export function useHashHighlight(cardId?: string): boolean {
  const location = useLocation();
  const [isHighlighted, setIsHighlighted] = useState(false);

  useEffect(() => {
    const hash = location.hash.slice(1);

    // "{cardId}~comment-{id}" адресует комментарий внутри карточки —
    // сама карточка тоже должна мигнуть, а не только комментарий.
    if (cardId && (hash === cardId || hash.startsWith(`${cardId}~`))) {
      setIsHighlighted(true);
      const timer = setTimeout(() => setIsHighlighted(false), 2000);

      return () => clearTimeout(timer);
    }
    // переход на тот же хэш всё равно перезапускает подсветку.
  }, [location.hash, location.key, cardId]);

  return isHighlighted;
}
